import React from 'react';
import { UserSelect } from '../../common/UserSelect';
export var UserField = function UserField(props) {
  return props.visible && /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: props.id || props.name
  }, props.label), /*#__PURE__*/React.createElement(UserSelect, {
    textMode: true,
    value: props.value,
    onChange: props.onChange,
    onBlur: props.onBlur,
    onFocus: props.onFocus
  }));
};